<template>
    <div v-if="license">
        <Dialog v-model:visible="visible" :style="{ width: '500px' }" header="License Details" :modal="true" :dismissableMask="true" @hide="$emit('hide-dialog', true)">
            <div class="surface-section">
                <ul class="list-none p-0 m-0 preview-section">
                    <li class="border-top-1 surface-border">
                        <div class="text-500 w-6 md:w-4 font-medium">License Id</div>
                        <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{{ license.id }}</div>
                    </li>
                    <li class="border-top-1 surface-border">
                        <div class="text-500 w-6 md:w-4 font-medium">Product Code</div>
                        <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                            <Chip :label="license.product.code"></Chip>
                        </div>
                    </li>
                    <li class="border-top-1 surface-border">
                        <div class="text-500 w-6 md:w-4 font-medium">Product description</div>
                        <div class="text-900 md:w-8 md:flex-order-0 flex-order-1">{{ license.product.description }}</div>
                    </li>
                    <li class="border-top-1 surface-border">
                        <div class="text-500 w-6 md:w-4 font-medium">Start Date</div>
                        <div class="text-900 md:w-8 md:flex-order-0 flex-order-1">{{ license.start_date }}</div>
                    </li>
                    <li class="border-top-1 surface-border">
                        <div class="text-500 w-6 md:w-4 font-medium">End Date</div>
                        <div class="text-900 md:w-8 md:flex-order-0 flex-order-1">{{ license.end_date }}</div>
                    </li>
                    <li class="border-top-1 surface-border">
                        <div class="text-500 w-6 md:w-4 font-medium">Auto Renewal Period</div>
                        <div class="text-900 md:w-8 md:flex-order-0 flex-order-1">{{ license.auto_renew + ' months' }}</div>
                    </li>
                </ul>
            </div>
        </Dialog>
    </div>
</template>

<script setup>
import { ref, defineProps } from 'vue';

const props = defineProps({
    license: {
        type: Object,
        required: true,
    },
});

const license = ref(props.license);
const visible = ref(true);
</script>
